//
// Copyright (c) 2020 Astute Global, Inc.
//

define([
  "backbone",
  "marionette",
  "underscore",
  "messaging/messenger",
  "./tableOfContentsLevelView",
], function (Backbone, Marionette, _, Messenger, TableOfContentsLevelView) {
  "use strict";

  var TableOfContentsLevelModule = Marionette.Controller.extend({
    initialize: function (options) {
      this.region = options.region;
      this.name = "tableOfContentsLevel";
      this._setUpVents();
    },
    show: function (tableOfContents) {
      this.levels = tableOfContents.levels();
      this.categories = Messenger.reqres.request("kb:categories");
      this.view = new TableOfContentsLevelView.listView({
        collection: this.levels,
        model: new Backbone.Model({
          categories: this.categories,
        }),
      });
      this.view.on("level:add", this._onLevelAdd, this);
      this.view.on("itemview:level:move:down", this._onLevelMoveDown, this);
      this.view.on("itemview:level:move:up", this._onLevelMoveUp, this);
      this.view.on("itemview:level:remove", this._onLevelRemove, this);
      this.showRegion(this.view, { loading: true, entity: this.levels });
    },
    _onLevelAdd: function () {
      var categoryId = this.view.getCategoryId();
      if (categoryId) {
        var category = this.categories.get(categoryId);
        if (category) {
          this.levels.addLevel(category);
          this.view.render();
        }
      }
    },
    _onLevelMoveDown: function (view) {
      var model = view.model;
      this.levels.moveDown(model);
      this.view.render();
    },
    _onLevelMoveUp: function (view) {
      var model = view.model;
      this.levels.moveUp(model);
      this.view.render();
    },
    _onLevelRemove: function (view) {
      var model = view.model;
      this.levels.remove(model);
      this.view.render();
    },
    _setUpVents: function () {
      Messenger.vent.on(
        "department:kb:changed",
        function (kbId) {
          this.selectedKbId = kbId;
          this._filterUsers();
        },
        this,
      );
      Messenger.vent.on(
        "department:locale:changed",
        function (localeId) {
          this.selectedLocaleId = localeId;
          this._filterUsers();
        },
        this,
      );
    },
  });

  return TableOfContentsLevelModule;
});
